import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Markdown from 'react-markdown';
import MdStar from 'react-icons/lib/md/star';
import './styles.scss';

export default class UpsellButton extends Component {
  static propTypes = {
    content: PropTypes.string,
  };

  render() {
    const { content, color } = this.props;

    const popoverContent = (
      <Popover
        className="popover-content"
        id={Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, '')
          .substr(0, 15)}
      >
        <Markdown source={content} />
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" overlay={popoverContent} rootClose>
        <div className="info-button-icon">
          <MdStar style={{ padding: '1px', color: color }} />
        </div>
      </OverlayTrigger>
    );
  }
}
